import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';

export default function FormDialog({ openState, message = '', caption = '', onChangeOpenState, showWhatsappLink = false }) {

    return (
        <Dialog
            open={openState}
            onClose={onChangeOpenState}
            PaperProps={{
                sx: {
                    background:
                        "radial-gradient(ellipse at 20% 30%, #191e26, #0a0c10)",
                    border: "1px solid rgba(230,57,70,0.4)",
                    borderRadius: "24px",
                    minWidth: "350px",
                    boxShadow:
                        "0 20px 40px rgba(0,0,0,0.8), 0 0 20px rgba(230,57,70,0.15)",
                },
            }}
        >
            <DialogContent sx={{ textAlign: "center", pt: 4 }}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 700,
                        background:
                            "linear-gradient(135deg,#fff,#e63946,#ffb347)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        mb: 1,
                    }}
                >
                    {message}
                </Typography>

                <Typography
                    sx={{
                        color: "#b9c7d9",
                        fontSize: "15px",
                        lineHeight: 1.8,
                        whiteSpace: "pre-line",
                        mt: 2,
                        maxWidth: "450px",
                        mx: "auto",
                    }}
                >
                    {caption}
                </Typography>

                {showWhatsappLink && (
                    <Typography
                        component="a"
                        href="https://wa.me/919747392492?text=Hello%20RitzMotoClub%20Admin,%20I%20have%20submitted%20my%20membership%20application." // admin number
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            display: "block",
                            mt: 3,
                            color: "#25D366",
                            fontWeight: 600,
                            textDecoration: "none",

                            "&:hover": {
                                textDecoration: "underline",
                            },
                        }}
                    >
                        💬 Contact Admin on WhatsApp
                    </Typography>
                )}
            </DialogContent>

            <DialogActions
                sx={{
                    justifyContent: "center",
                    pb: 3,
                    px: 3,
                }}
            >
                <Button
                    onClick={onChangeOpenState}
                    sx={{
                        px: 4,
                        py: 1.2,
                        borderRadius: "999px",
                        color: "#fff",
                        fontWeight: 700,
                        background:
                            "linear-gradient(105deg,#e63946,#b91c2c)",
                        boxShadow:
                            "0 8px 20px rgba(230,57,70,0.35)",

                        "&:hover": {
                            background:
                                "linear-gradient(105deg,#f04d5b,#d62535)",
                            transform: "translateY(-1px)",
                        },
                    }}
                >
                    OK
                </Button>

            </DialogActions>
        </Dialog>
    );
}